import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {TranslateService} from '../../services/translate.service';
import {User} from '../../models/user.model';
import {Observable} from 'rxjs/Observable';
import {UserService} from '../../services/user.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent {

  currentLanguage = 'hu';
  currentUser$: Observable<User>;
  permissions = [];

  constructor(private auth: AuthService, private userService: UserService, private translateService: TranslateService) {
    this.currentUser$ = this.userService.getCurrentUser();
  }

  onChangeLanguage(lang, $event) {
    $event.preventDefault();
    this.translateService.language = lang;
    this.currentLanguage = lang;
  }

  onLogout(event) {
    event.preventDefault();
    return this.auth.logout();
  }

}



// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/shared/layouts/navigation/navigation.component.ts